import { JSX, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaFilePdf } from 'react-icons/fa';
import { Statistic } from '../../components/statistic';
import { useHabit } from '../../hooks/habit.hook';
import { useLayout } from '../../hooks/layout.hook';
import { useNavigation } from '../../hooks/navigation.hook';
import { useRecord } from '../../hooks/record.hook';

export default function StatisticScreen(): JSX.Element {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const { habitsLoading, habits } = useHabit();
  const { recordsLoading, recordsByHabit } = useRecord();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useLayout(
    () => ({
      activeMenu: 'statistic',
      title: t('Statistic'),
      loading: habitsLoading || recordsLoading,
    }),
    [t, habitsLoading, recordsLoading],
  );

  const hasRecords = habits.length > 0 && Object.values(recordsByHabit).some((r) => r && r.length > 0);

  return (
    <Statistic
      habits={habits}
      records={recordsByHabit}
      activeFooter={
        hasRecords && (
          <button className="btn btn-lg btn-neutral w-full" onClick={() => navigate('/statistic/report')}>
            <FaFilePdf />
            {t('Export as PDF')}
          </button>
        )
      }
    />
  );
}
